module.exports = __webpack_public_path__ + "img/about-4.de9c71b2.png";